// extracted by mini-css-extract-plugin
export default {"menuItem":"Header_menuItem__UiVP2","hidden":"Header_hidden__OsAwe"};